
import { paths } from 'src/routes/paths';
// utils
import axios from 'src/utils/axios';

// ----------------------------------------------------------------------

function jwtDecode(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};
const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem('refreshToken');

    if (!refreshToken) {
      throw new Error('Không tìm thấy refreshToken, cần đăng nhập lại.');
    }

    const response = await axios.post('/hosons/refresh', { refreshToken });

    const { accessToken } = response.data;

    // Cập nhật accessToken mới vào localStorage và headers
    localStorage.setItem('accessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    return accessToken;
  } catch (error) {
    console.error('Lỗi khi refresh token:', error);
    return null;
  }
};
// ----------------------------------------------------------------------
// Khi vào trang web đã xác thực từ trước thì sẽ thêm token
export const tokenExpired = async (exp: number) => {
  if (!exp) return; // Tránh lỗi nếu exp không hợp lệ

  const currentTime = Date.now() / 1000; // Đổi sang giây để so sánh với exp
  const timeLeft = (exp - currentTime) * 1000; // Đổi lại milliseconds

  if (timeLeft <= 0) {
    const newAccessToken = await refreshAccessToken();
    console.log('newAccessToken',newAccessToken)

    if (newAccessToken) {
      setSession(newAccessToken);
    } else {
      alert('Đã hết hạn xác thực người dùng. Vui lòng đăng nhập lại!!');
      localStorage.removeItem('accessToken');
      window.location.href = paths.auth.jwt.login;
      return;
    }
  }

  // Thiết lập timer để tự động logout khi token hết hạn
  setTimeout(async() => {
    const newAccessToken = await refreshAccessToken();

    if (newAccessToken) {
      console.log("Token đã được làm mới!");
      setSession(newAccessToken);
    } else {
      alert("Phiên làm việc hết hạn. Vui lòng đăng nhập lại!");
      localStorage.removeItem("accessToken");
    window.location.href = paths.auth.jwt.login;
    }
  }, timeLeft - 60000);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken: string | null) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
    tokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');

    delete axios.defaults.headers.common.Authorization;
  }
};
